import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var LinkItem = function LinkItem(_ref) {
  var href = _ref.href,
      text = _ref.text;
  var getClassName = getClassNameFactory("DismissibleBannerLinkItem");
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("a", {
    href: href
  }, text));
};

LinkItem.displayName = "DismissibleBanner.LinkItem";
export default LinkItem;